export default {
  saveToStorage(key, data) {
    window.localStorage.setItem(key, JSON.stringify(data));
  },
  readFromStorage(key) {
    return JSON.parse(window.localStorage.getItem(key));
  },
};
